import { http } from "./api";
import { readJson, writeJson, removeKey } from "./storage";

// Taslak deposu: tarayıcı (oturum süresince, anında) + sunucu (kullanıcı bazlı, 600ms gecikmeli) — başka bilgisayardan girişte sunucudaki taslak önceliklidir
// Yalnız form taslakları / filtre ön ayarları saklanır; kimlik bilgisi veya token asla yazılmaz (oturum httpOnly çerezde)
const timers = {};
const local = {
  get(key) { return readJson(key, null); },
  set(key, v) { writeJson(key, v); },
  remove(key) { removeKey(key); removeKey(key, localStorage); }, // eski sürümün localStorage kopyası da temizlenir
};
// Aynı oturumun (yerel, 4 saatten yeni) taslağı sayfa yenilemesi sonrası sorulmadan geri yüklenir; sunucudan/eski taslak için kullanıcıya sorulur
export const isFreshLocal = (d) => !!d && !d.remote && Date.now() - new Date(d.at || 0).getTime() < 4 * 60 * 60 * 1000;

export const draftStore = {
  hasLocal(key) { return sessionStorage.getItem(key) != null; },
  async load(key) {
    const mine = local.get(key);
    try {
      const r = await http.get(`/drafts/${encodeURIComponent(key)}`);
      const remote = r.data?.data ? { ...r.data.data, at: r.data.data.at || r.data.at, remote: true } : null;   // karşılaştırma taslağın kendi zamanıyla (sunucu saati değil)
      if (remote && (!mine || (remote.at || "") > (mine.at || ""))) return remote;   // eşitlikte yerel (aynı oturum) kopya kazanır
    } catch (e) { console.warn(`[draft] sunucu taslağı alınamadı (${key}); yerel kopya kullanılıyor`, e); }
    return mine;
  },
  save(key, data) {
    const payload = { ...data, at: new Date().toISOString() };
    local.set(key, payload);
    clearTimeout(timers[key]);
    timers[key] = setTimeout(() => { http.put(`/drafts/${encodeURIComponent(key)}`, { data: payload }).catch(() => {}); }, 600);
  },
  clear(key) {
    local.remove(key);
    clearTimeout(timers[key]);
    http.delete(`/drafts/${encodeURIComponent(key)}`).catch(() => {});
  },
};
